





































































import { Vue, Component } from "vue-property-decorator";
import store from "@/vuex/index";
import Bus from "@/common/util/bus";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import store1 from "@/vuex/modules/login";
import { Public } from "@/http/api_Public";
// import { WorkPlaces,TbEmployee,SystemSettings } from '@/http'
// import RongIM from '@/common/util/rongcloud';
@Component({
  components: {},
})
export default class WorkHeaderBar extends Vue {
  public sysUserName: string = "";
  public time = "上午好";
  public userinfo = {
  };
  loginInfo = {};
  sex = "";
  realName = "";
  avatarPath = null;
  departmentName = "";
  rongYunToken = "";
  isPlateform: boolean = false;
  logo: boolean = false;
  admin: boolean = true;
  gretting = "";
  ry: any;
  timer: any;
  userInfo: any = {};

  dialogVisible = false;
  /**店铺列表 */
  storeList = [];
  activeId = '';
  activeName = '';

  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
    // Bus.$on("logoUrl", (v) => {
    //   if (localStorage.getItem("dayChecked") == "true") {
    //     localStorage.setItem("avatarPath", v);
    //   } else {
    //     sessionStorage.setItem("avatarPath", v);
    //   }

    //   this.avatarPath = v;
    // });
  }
  /**vuex变更权限 */
  @Mutation("login/clearjurisdiction") clearjurisdiction;

  helpFun() {
    window.open(
      "https://www.logidelta.com/develop/apiServiceDetail/e1c07aac-9fd9-4324-9af0-3295729d0ecc?id=0A42C860-28FE-4389-AF0F-C0336ADAC918",
      "_blank"
    );
  }

  //退出登录
  logOut() {
    this.$confirm("确认退出吗?", "提示", {
      type: "warning",
    })
      .then(async () => {
        store.state.isFirst = true;
        store.state.jurisdiction = [];
        await this.clearjurisdiction([]);
        let dayChecked = localStorage.getItem("dayChecked");
        if (dayChecked == "true") {
          localStorage.clear();
        } else {
          sessionStorage.clear();
        }
        await location.reload();
        this.$router.push("/login");
      })
      .catch(() => {});
  }
  handleCommand(command) {
    command == "切换门店" ? this.openDia() : this.logOut();
  }
  goHome() {
    this.$router.push("/systemSetting/personalInfo");
  }
  beforeDestory() {
    clearInterval(this.timer);
  }
  async openDia(){
    await this.getStoreList();
    this.$nextTick(()=>{
      this.dialogVisible = true;
    })
  }
  /**关闭新增弹框 */
  public async handlePPClose() {
    this.dialogVisible = false;
  }
  chooseShopId(item){
    console.log('itemitem',item);
    this.activeId = item.id;
    this.activeName = item.shopName;
  }
  async confirmMd(){
    let obj = Object.assign({},this.userInfo,{
        shopId:this.activeId,
        shopName:this.activeName
    })
    localStorage.setItem("userInfo",JSON.stringify(obj));
    this.handlePPClose();
    await location.reload();
  }
  /**获取店铺列表 */
  async getStoreList() {
    let res = await Public.GetTbShoppListForSwitch({
        shopId: JSON.parse(localStorage.getItem("userInfo")).shopId,
    });
    this.storeList = res.filter(v=>v.isUpdate==true);
    this.activeId = JSON.parse(localStorage.getItem("userInfo")).shopId;
    this.activeName = JSON.parse(localStorage.getItem("userInfo")).shopName;
    console.log('this.storeList',this.storeList);
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/homenew/components/HeaderBar.vue